export default "__VITE_ASSET__7627b8a5__"